import type { RouteMiddleware, MiddlewareContext, RouteInfo } from '../types';
import { createDevLogRouter } from './router';

interface DevLogsMiddlewareOptions {
  /** Directory containing log files */
  logDir?: string;
}

/**
 * Routes provided by dev logs middleware
 */
const DEV_LOGS_ROUTES: RouteInfo[] = [
  {
    method: 'GET',
    path: '/app/trace/:traceId',
    description: 'Get log entries by trace ID',
  },
  {
    method: 'GET',
    path: '/trace/recent',
    description: 'Get recent trace calls with pagination and optional path/method filters',
  },
  {
    method: 'GET',
    path: '/files/:fileName',
    description: 'Get paginated log file content by file name',
  },
  {
    method: 'GET',
    path: '/server-logs',
    description: 'Get server logs in ServerLog format (compatible with frontend)',
  },
  {
    method: 'GET',
    path: '/trace/trigger/list',
    description: 'Get trigger list (automation trigger) in trace.log',
  },
  {
    method: 'GET',
    path: '/trace/trigger/:instanceID',
    description: 'Get trigger detail (automation trigger) in trace.log by instanceID',
  },
  {
    method: 'GET',
    path: '/api-list',
    description: 'Get all API routes grouped by module',
  },
];

/**
 * Creates dev logs middleware for viewing application logs
 * Supports both rspack/webpack and Vite dev servers
 */
export function createDevLogsMiddleware(options: DevLogsMiddlewareOptions = {}): RouteMiddleware {
  const { logDir } = options;

  return {
    name: 'dev-logs',
    mountPath: '/dev/logs',
    routes: DEV_LOGS_ROUTES,

    enabled: (context: MiddlewareContext) => context.isDev,

    createRouter: (context: MiddlewareContext) => {
      return createDevLogRouter({ logDir: logDir || context.logDir });
    },
  };
}
